import React from "react";
import { TableViewStore, BaseListViewStore } from 'core/stores';
import { resolveColumns } from 'application/facility/util/resolveColumns';
import { applicationContext, uuid } from 'core/utils';
import { BaasicButton } from 'core/components';
import { action, observable } from 'mobx';
import { InsuranceService } from 'application/import-reference/services';
import _ from 'lodash';

@applicationContext
class InsuranceOrderingListViewStore extends BaseListViewStore {
    tabItems = [{ name: "Primary Insurances", abrv: "primarySort" }, { name: "Secondary Insurances", abrv: "secondarySort" }];
    @observable accessor selectedStatusAbrv = "primarySort";
    @observable accessor insuranceOrdering = [];

    constructor(rootStore) {
        const service = new InsuranceService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'insurance-ordering',
            autoInit: true,
            authorization: {
                create: 'portalSection.create',
                delete: 'portalSection.delete',
            },
            routes: {},
            actions: () => {
                return {
                    find: async (params) => {
                        params.pageNumber = this.setPage ? parseInt(this.rootStore.routerStore.routerState.queryParams.page) : params.pageNumber;
                        this.setPage = false;
                        this.rootStore.routerStore.routerState.queryParams.page = params.pageNumber;

                        var response = await service.find({ ...params, sort: `${this.selectedStatusAbrv}|asc`, isPrimarySort: this.selectedStatusAbrv === "primarySort" });

                        var insuranceOrderingSort = await service.find({ rpp: 10000, sort: `${this.selectedStatusAbrv}|asc`, isPrimarySort: this.selectedStatusAbrv === "primarySort"});
                        this.insuranceOrdering = insuranceOrderingSort.data.item;

                        return response.data;
                    }
                }
            }
        });

        this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: resolveColumns([
                {
                    key: 'name',
                    title: 'Name',
                    sortable: false
                },
                {
                    key: 'sort',
                    title: 'Sort',
                    cell: (item) => {
                        return (
                            <td>
                                <div className="u-flex--primary u-flex--no-wrap" key={uuid()}>
                                    <input
                                        className="input input--sml input--table u-mar--right--tny"
                                        onClick={(e) => e.target.select()}
                                        onBlur={(e) => {
                                            this.updateItem(item.dataItem, null, e.target.value)
                                        }}
                                        defaultValue={item.dataItem[this.selectedStatusAbrv]}
                                        min="1"
                                        type="integer"
                                    />

                                    <div className="table__icons">
                                        <BaasicButton
                                            className="btn btn--icon"
                                            icon="u-icon u-icon--arrow-up u-icon--sml"
                                            label="Up"
                                            onlyIcon={true}
                                            onClick={() => { this.updateItem(item.dataItem, 'up') }}
                                        ></BaasicButton>
                                        <BaasicButton
                                            className="btn btn--icon"
                                            icon="u-icon u-icon--arrow-down u-icon--sml"
                                            label="Down"
                                            onlyIcon={true}
                                            onClick={() => { this.updateItem(item.dataItem, 'down') }}
                                        ></BaasicButton>
                                    </div>
                                </div>
                            </td >
                        )
                    }
                }
            ]),
            actions: {
                onDelete: async (item) => this.deleteResource(item)
            }
        }));

        this.service = service;
    }

    @action.bound
    async setStatus(statusAbrv) {
        this.selectedStatusAbrv = statusAbrv;
        this.queryUtility.fetch();
    }

    @action.bound
    getInsuranceOrderingDownloadUrl() {
        const parameters = this.queryUtility.plainFilter;
        const downloadInsuranceOrderingUrl = `${this.service.getDownloadUrl({ ...parameters })}&contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl}&ttype=${this.rootStore.authStore.token.type}`
        window.open(downloadInsuranceOrderingUrl, "_blank");
    }

    @action.bound
    uploadInsuranceOrdering() {
        this.rootStore.routerStore.goTo('master.app.main.insurance-ordering.upload');
    }

    @action.bound
    createNewInsuranceOrdering() {
        this.rootStore.routerStore.goTo('master.app.main.insurance-ordering.create');
    }

    @action.bound
    async updateItem(item, direction, value) {
        let swapItem = null;
        if (direction) {
            if (!item[this.selectedStatusAbrv]) {
                const numbers = _.map(this.insuranceOrdering.filter(po => po[this.selectedStatusAbrv]), (po) => { return po[this.selectedStatusAbrv] });
                item[this.selectedStatusAbrv] = numbers.length > 0 ? Math.max(...numbers) + 1 : 1;
            }
            else {
                var index = this.insuranceOrdering.findIndex(p => p.id === item.id);
                if (direction === 'up') {
                    if (item[this.selectedStatusAbrv]  === 1) {
                        return;
                    }
                    else {
                        item = this.insuranceOrdering[index];
                        const temp = this.insuranceOrdering[index - 1][this.selectedStatusAbrv];
                        this.insuranceOrdering[index - 1][this.selectedStatusAbrv] = item[this.selectedStatusAbrv];
                        item[this.selectedStatusAbrv] = temp;
                        swapItem = this.insuranceOrdering[index - 1];
                    }
                }
                else {
                    if (this.insuranceOrdering[index + 1] && this.insuranceOrdering[index + 1][this.selectedStatusAbrv]) {
                        item = this.insuranceOrdering[index];
                        const temp = this.insuranceOrdering[index + 1][this.selectedStatusAbrv];
                        this.insuranceOrdering[index + 1][this.selectedStatusAbrv] = item[this.selectedStatusAbrv];
                        item[this.selectedStatusAbrv] = temp;
                        swapItem = this.insuranceOrdering[index + 1];
                    }else{
                        return;
                    }
                }
            }
        } 
        else {
            if (value && parseInt(value) < 1) {
                value = 1;
            }

            if(!this.insuranceOrdering.some(i => i[this.selectedStatusAbrv] == value && i.id !== item.id)){
                item[this.selectedStatusAbrv]  = value;
            }else{
                this.rootStore.notificationStore.error(
                    `Insurance with sort number ${value} already exists.`
                );
            }
        }

        let items = swapItem ? [item, swapItem] : [item];

        try{
            await this.service.batchUpdate(items);
        }
        catch(err) {
            this.rootStore.notificationStore.error(err && err.data && err.data.Message ? err.data.Message : 'Error occured while trying to update the insurance ordering.');
        }

        this.queryUtility.filter.set("page", parseInt(this.rootStore.routerStore.routerState.queryParams.page) ? parseInt(this.rootStore.routerStore.routerState.queryParams.page) : 1 );
        this.setPage = true;
        this.queryUtility.fetch();
    }

    @action.bound
    async deleteResource(item) {
        const { modalStore, notificationStore } = this.rootStore;

        modalStore.showConfirm(
            'INSURANCE_ORDERING.DELETE.CONFIRM',
            async () => {
                try {
                    item[this.selectedStatusAbrv] = null;
                    await this.service.update(item);
                    notificationStore.success('INSURANCE_ORDERING.DELETE.SUCCESS');
                    this.queryUtility.filter.set("page", parseInt(this.rootStore.routerStore.routerState.queryParams.page));
                    this.setPage = true;
                    await this.queryUtility.fetch();
                } catch (err) {
                    notificationStore.error('LIST_LAYOUT.ERROR_DELETE', err);
                }
            }
        );
    }
}

export default InsuranceOrderingListViewStore;
